import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  loaderImg: {
    height: '100px',
    width: '100px',
  },
}));
